<template>
    <div class="modal fade fs-5" id="alertModal" ref="alertModal" tabindex="-1" :data-bs-backdrop="backdrop" aria-labelledby="alertModal" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h2 class="modal-title fs-2">{{ alertSubject }}</h2>
            <button v-if="isDismiss" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div id="alert-modal-body" class="modal-body" v-html="alertContent"></div>
          <div class="modal-footer">
            <input type="hidden" id="is-hidden" v-model="isHidden">
            <button type="button" id="ok-btn" disabled class="btn btn-primary" data-bs-dismiss="modal" @click="redirectTo(redirectUrl)">
              موافق <span id="enable-timer">({{ enableTimer }})</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import router from '@/router';
  
  export default {
    name: "AlertModal",
    props: {
      alertContent: String,
      alertSubject: {
        default: "تنبيه",
        type: String
      },
      backdrop: {
        default: "static",
        type: String
      },
      isDismiss: {
        default: true,
        type: Boolean
      },
      timeToEnable: {
        default: 0,
        type: Number
      },
      redirectUrl: {
        default: "0",
        type: String
      }
    },
    data() {
      return {
        isHidden: 1,
        enableTimer: this.timeToEnable,
      };
    },
    methods: {
      redirectTo() {
        if (this.redirectUrl == '1') {
          router.push("/");
        } else if (this.redirectUrl != '0') {
          router.push({ path: this.redirectUrl });
        }
      }
    },
    watch: {
      isHidden(value) {
        const timer = document.getElementById("enable-timer");
        const button = document.getElementById("ok-btn");
        if (!value) {
          if (this.enableTimer > 0) {
            button.disabled = true;
            const intervalID = setInterval(() => {
              this.enableTimer--;
              if (this.enableTimer < 1) {
                timer.style.display = 'none';
                button.disabled = false;
                clearInterval(intervalID);
              }
            }, 1000);
          } else {
            timer.style.display = 'none';
            button.disabled = false;
          }
        }
      }
    }
  }
  </script>